import api from "../apiConfig";
// eslint-disable-next-line import/no-anonymous-default-export
const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(p) {
    const params = paramsFactory(p);
    return api.get(`/api/v1/suspension-over-time?${params}`);
  },
  changeStatus(id, status) {
    return api.put(`/api/v1/suspension-over-time/${id}`, {
      status_id: status,
    });
  },
  update(data) {
    return api.put(`/api/v1/suspension-over-time/over-time/${data.id}`, data);
  },
};
